import yqDialogHint from './YqDialogHint'
import selectLine from './select-line.vue'
import progressBar from './ProgressBar.vue'
import dialogProgressBar from './DialogProgressBar.vue'
import loadingMask from './LoadingMask.vue'

export default {
	install(Vue) {
		Vue.component('yq-dialog-hint', yqDialogHint)
		Vue.component('yq-select-line', selectLine)
		Vue.component('yq-progress-bar', progressBar)
		Vue.component('yq-dialog-progress-bar', dialogProgressBar)
		Vue.component('yq-loading-mask', loadingMask)
	}
}
